export default {"src":"/_next/static/media/img-testicon-cylinder.46be6b6c.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};